import { useState, useRef, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Watch } from "lucide-react";
import { config } from "../../Environment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

// content is like { key, label }
// defaultValue has the current value of the component (or null)
const Timestamp = ({ processId, userData = {}, itemkey, defaultValue, content, onChange }) => {

  const { t } = useTranslation();

  console.log(`[Timestamp] existing value ${JSON.stringify(defaultValue)}`);

  // keep the same timestamp value across re-renders
  const timestampValue = useMemo(() => {
    const value = defaultValue ?? Date.now();
    return value;
  }, []);

  useEffect(() => {
    onChange(content.key, timestampValue);
  }, [timestampValue]);

  return (
    <div className="mt-3 text-start">
      {content.visible ? (
        <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-cyan-50 to-primary/5 border border-cyan-300 shadow-sm">
          <Watch className="w-4 h-4 text-cyan-600" />
          <div>
            <span className="text-xs font-semibold text-gray-700 block">
              {content.label ?? t("timestamp")}
            </span>
            <span className="text-sm font-mono font-bold text-cyan-700">
              {timestampValue}
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Timestamp;
